// Click scroll to element on the page when clicking a link in the navbar
! (() => {
    let navbar = document.querySelector('#navbar');
    if (! navbar) return;

    // Change from "sticky-top" to "fixed-top" on mobile devices
    const makeNavbarFixedOnMobile = () => {
        let isMobile = window.matchMedia("(max-width: 768px)").matches;
        if (isMobile) {
            navbar.classList.remove('sticky-top');
            navbar.classList.add('fixed-top');
        } else {
            navbar.classList.remove('fixed-top');
            navbar.classList.add('sticky-top');
        }
    };

    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(makeNavbarFixedOnMobile, 100);
    });

    makeNavbarFixedOnMobile();



    /*
    // Wait until the page is fully loaded and rendered
    const waitForPageToLoad = () => {
        return new Promise(resolve => {
            if (document.readyState === 'complete') {
                // If already loaded, resolve immediately
                setTimeout(resolve, 100); // Small delay to ensure all calculations are done
            } else {
                // Wait for the load event
                window.addEventListener('load', () => {
                    setTimeout(resolve, 100);
                });
            }
        });
    };

    const scrollToTarget = (targetEl, offset = 0) => {
        // Use getBoundingClientRect for more accurate positioning
        const targetPosition = targetEl.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: targetPosition - offset,
            behavior: 'smooth'
        });
    };

    const uriIsTheSamePage = (target) => {
        // Check if the target is on the same page
        let currentUrl = window.location.href.split('#')[0];
        let targetUrl = target.href.split('#')[0];
        return currentUrl === targetUrl;
    };

    let gotoLinks = navbar.querySelectorAll('[data-go-to]');

    // // Scroll to element when clicking a link
    // gotoLinks.forEach((link) => {
    //     link.addEventListener('click', async (e) => {
    //         // Skip scrolling if it's not the same page
    //         if (! uriIsTheSamePage(link)) {
    //             return;
    //         }
            
    //         // Prevent default to handle scroll manually
    //         e.preventDefault();
            
    //         // Get target element
    //         let targetEl = document.querySelector(link.dataset.target);
    //         if (!targetEl) return;
            
    //         // Close mobile navbar if open
    //         // let navbarCollapse = document.querySelector('.navbar-collapse.show');
    //         // if (navbarCollapse) {
    //         //     let bsCollapse = new bootstrap.Collapse(navbarCollapse);
    //         //     bsCollapse.hide();
    //         //     // Wait for collapse animation to finish
    //         //     await new Promise(resolve => setTimeout(resolve, 350));
    //         // }
            
    //         // Calculate navbar height for offset
    //         const navbarHeight = navbar.offsetHeight;
            
    //         // Add a small delay to ensure any layout shifts have happened
    //         setTimeout(() => {
    //             if (link.dataset.target === 'footer') {
    //                 scrollToelement(targetEl);
    //             } else {
    //                 scrollToTarget(targetEl, navbarHeight);
    //             }
                
    //             // Update URL hash without triggering another scroll
    //             // history.pushState(null, null, link.href);
    //         }, 50);
    //     });
    // });

    // Handle page load scrolling with hash
    const handleHashScroll = async () => {
        let hash = window.location.hash;
        if (!hash) return;
        
        // Wait for page to be fully loaded
        await waitForPageToLoad();
        
        // Find matching link
        for (let link of gotoLinks) {
            if (link.href.endsWith(hash)) {
                let targetEl = document.querySelector(link.dataset.target);
                if (targetEl) {
                    // Wait for any animations or layout shifts to complete
                    setTimeout(() => {
                        const navbarHeight = navbar.offsetHeight;
                        // if (link.dataset.target === 'footer') {
                        //     scrollToelement(targetEl, 0);
                        // } else {
                        //     scrollToTarget(targetEl, navbarHeight);
                        // }

                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(targetEl).offset().top + navbarHeight - 100
                        }, 2000);

                    }, 300);
                }
                break;
            }
        }
    };

    // Run hash scroll handling
    handleHashScroll();
    
    // Add resize event listener to handle position recalculation after resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            // Re-run hash scroll if there's a hash in the URL
            if (window.location.hash) {
                handleHashScroll();
            }
        }, 100);
    });
    */
})();